module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIwMSIgdmlld0JveD0iMCAwIDMwMSAyMDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjMEQ1RUFGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0uNS41aDMwMHYyMDBILjV6Ii8+PHBhdGggZD0iTTU2LjA1Ni41djEyMi4yMjJNLjUgNTYuMDU1aDExMS4xMTFtMC0yMi4yMjJIMzAwLjVNMTExLjYxMSA3OC4yNzhIMzAwLjVNLjUgMTIyLjcyMmgzMDBNLjUgMTY3LjE2N2gzMDAiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSIyMCIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-gr.svg
// module id = ckPk
// module chunks = 2